import { useState, useEffect, useCallback } from 'react';
import { getManagements, ManagementDto } from '../services/ManagementService';

export const useManagements = (enabled: boolean) => {
  const [managements, setManagements] = useState<ManagementDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchManagements = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getManagements();
      if (response.success && Array.isArray(response.data)) {
        setManagements(response.data as ManagementDto[]);
      } else {
        const msg =
          typeof response.message === 'string' ? response.message : 'Error al cargar gerencias';
        setError(msg);
        setManagements([]);
      }
    } catch {
      setError('Error al cargar gerencias');
      setManagements([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setManagements([]);
      return;
    }
    void fetchManagements();
  }, [enabled, fetchManagements]);

  return { managements, isLoading, error, refreshManagements: fetchManagements };
};
